import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProductComponent } from '../../product.component';
import { ProductCategoryMobileComponent } from '../category/index.component';
import { Key } from 'readline';

@Component({
  selector: 'app-product-mobile-list',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class ProductListMobileComponent extends ProductComponent {
  @ViewChild (ProductCategoryMobileComponent) mobileCategory!: ProductCategoryMobileComponent;

  selectedProductListVisible: boolean = false;
  storageProductList: any[] = [];
  // select product drawer
  checkedAll: boolean = false;
  selectedProductList: any[] = [];
  
 
  get showLoadingMore(){
    const len = this.productList?.length || 0;
    return len < this.pagination.total;
  }
  get materialNo(){
    return this.productList?.filter(item=> (item?.mobileQuantity || 0) > 0)?.reduce((pre, next)=>{
      return pre + next?.mobileQuantity
    }, 0)
  }
  get materialType(){
    return this.productList?.filter(item=> (item?.mobileQuantity || 0) > 0)?.length
  }
  get showDeleteIcon(){
    return this.selectedProductList?.some(item=> item.checked)
  }



  getProductTypeTagColor(name: string) :string{
    const TYPE: Record<string, string> = {
      '在售': 'success',
      '停产': 'danger',
      '产品准备中': 'waring',
    }
    return TYPE[name] || 'waring';
  }
 
  changeSearchTab(index: number) :void {
    this.searchTabsIndex = index;
  }

  handleSearchVin(){
    const country = localStorage.getItem("country");
    this.router.navigate(
      [`${country}/mobile/vin-search`], 
    );
  }
  handleSearchVehicle(){
    const country = localStorage.getItem("country");
    this.router.navigate(
      [`${country}/mobile/vehicle-search`], 
    );
  }

  handleSearchByCompany(){
    const country = localStorage.getItem("country");
    this.router.navigate(
      [`${country}/mobile/company-search`], 
    );
  }

  // 勾选
  handleChangeCarList(){
    this.productList = [];
    this.getList();
  }
  
  handleViewAllType(){
    this.mobileCategory.handleViewAllType()
  }
  // add to shopping cart
  handleAddCart(event: any){
    event.stopPropagation();
    const products = this.selectedProductList.map(item=>{
      return {
        expectedDate: this.commonService.formatDateString(item.expectedDate),
        quantity: item.quantity,
        inputMaterialNumber: item.articleNumber
      }
    })
    this.addProductListToCart(products)
  }
  // about category 
  handleSelectCategory(categoryList: string){
    this.category = JSON.parse(categoryList);
    this.getList();
  }
  handleRemoveCategory(name: string){
    this.category = this.category?.filter(item=> item !== name);
    this.getList();
  }

  // load more data
  handleLoadProductList(){
    this.pagination.pageIndex++;
    this.getList();
  }

  handleOpenVinResultList(){
    this.vinResultListVisible = !this.vinResultListVisible
  }

  // quantity input change event
  handleClickQuantityBox(e: Event){
    e.preventDefault()
    e.stopPropagation();
  }
  handleChangeQuantity(item: any) {
    const moq = item.minumQty === 0 ? 1 : item.minumQty;
    const quantity = item?.mobileQuantity || 0;
    if(!quantity){
      item.mobileQuantity = 0;
      item.quantityIsZero = true;
    }else if (quantity < moq) {
      item.mobileQuantity = moq;
      item.quantityIsZero = false;
    } else if (quantity % moq !== 0) {
      item.mobileQuantity = Math.ceil(quantity / moq) * moq;
      item.quantityIsZero = false;
    }
    this.getSelectedProductList()
  }
  // minus
  decrease(item: any) {
    item.mobileQuantity = (item.mobileQuantity || 0) - item.minumQty <= 0 ? 0: (item.mobileQuantity || 0) - item.minumQty;
    if(item.mobileQuantity === 0){
      item.quantityIsZero = true;
    }
    this.getSelectedProductList()
  }
  // plus
  increase(item: any) {
    item.mobileQuantity = (item?.mobileQuantity || 0) + item.minumQty;
    item.quantityIsZero = false;
    this.getSelectedProductList()
  }

  // selected product list drawer
  getSelectedProductList(){
    this.selectedProductList = this.productList?.filter(item=> (item?.mobileQuantity || 0) > 0)?.map(item=>{
      return {
        ...item,
        checked: false
      }
    })
  }
  handleToggleSelectProductDrawer(){
    setTimeout(()=>{
      this.selectedProductListVisible = !this.selectedProductListVisible;
      if(this.selectedProductListVisible){
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
      }else{
        document.body.style.overflow = 'auto';
        document.body.style.position = 'static';
      }
   
    }, 100)
  }
  handleCloseSelectProductDrawer(){
    this.selectedProductListVisible = false;
  }
  handleSelectAll(){
    this.selectedProductList = this.selectedProductList.map(item=> ({ ...item, checked: this.checkedAll }))
  }
  
  handleRemoveSelect(){
    const selectItems = this.selectedProductList.filter(item=> !item.checked)
    this.selectedProductList = selectItems;
    this.productList = this.productList.map(item=> ({...item, mobileQuantity: 0 }))
  }
 
}
